export default __webpack_public_path__ + "static/media/Outcome-of-Board-Meeting-May-15-2026.2f416346.pdf";